import { render } from "./Snowflake.vue?vue&type=template&id=8f11436c"
import script from "./Snowflake.vue?vue&type=script&lang=js"
export * from "./Snowflake.vue?vue&type=script&lang=js"

import "./Snowflake.vue?vue&type=style&index=0&id=8f11436c&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__